import config from '@/config'
import request from '@/modules/base/util/request'
import type { CouponDataType } from '@/modules/base/components/modal/upgrade-modal/order-overview/summary/overview-summary'

interface CouponSubscriptionType {
  name: string
  period?: string
}

/**
 * Checks a coupon code against the plans in the cart - the first plan it is valid for wins, as in
 * the previous order overview. Resolves with null when the code is valid for none of them.
 */
const validateCouponCode = async(code: string, subscriptionTypes: CouponSubscriptionType[], period: string): Promise<CouponDataType | null> => {
  for (const { name, period: subscriptionPeriod } of subscriptionTypes) {
    try {
      const response = await request(`${config.resourceHost}subscription/validateCoupon`, {
        auth: true,
        data: { subscriptionType: name, code, period: period || subscriptionPeriod },
      })
      return { ...response.body.data, subscriptionType: name }
    } catch {
      // not valid for this plan - try the next one
    }
  }
  return null
}

export default validateCouponCode
